var _rect, _rect2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2364,
    height: 1046,
    transform: "translate(-480 -362)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.47591 12.3261C6.06902 11.8913 5.41175 11.8913 5.00486 12.3261L2.30272 15.2139C1.89584 15.6488 1.89584 16.3512 2.30272 16.7861L5.00486 19.6739C5.41175 20.1087 6.06902 20.1087 6.47591 19.6739C6.8828 19.239 6.8828 18.5366 6.47591 18.1017L5.55781 17.1206H20.3413C20.9151 17.1206 21.3846 16.6188 21.3846 16.0056C21.3846 15.3923 20.9151 14.8906 20.3413 14.8906H5.56824L6.48634 13.9094C6.89323 13.4746 6.89323 12.7721 6.48634 12.3373L6.47591 12.3261Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5241 11.6712C17.931 12.106 18.5883 12.106 18.9952 11.6712L21.6973 8.78338C22.1042 8.34853 22.1042 7.6461 21.6973 7.21125L18.9952 4.32345C18.5883 3.8886 17.931 3.8886 17.5241 4.32345C17.1172 4.75829 17.1172 5.46073 17.5241 5.89557L18.4422 6.87676H3.64828C3.07446 6.87676 2.60498 7.3785 2.60498 7.99174H2.61541C2.61541 8.60498 3.0849 9.10672 3.65871 9.10672H18.4422L17.5241 10.0879C17.1172 10.5228 17.1172 11.2252 17.5241 11.66V11.6712Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSwitch);
export default __webpack_public_path__ + "static/media/icon-switch.7394f58a1d25b2e7721f02cb803c44a4.svg";
export { ForwardRef as ReactComponent };